// import { yieldPerBlock } from "./yieldPerBlock";
// import metadata from '../assets/metadata/metadata-prod.json';

const LEGENDARY_RARITY = "legendary"
const EPIC_RARITY = "epic"
const RARE_RARITY = "rare"
const UNCOMMON_RARITY = "uncommon"

const pNFT_RARITY_ENUM = Object.freeze({
    [LEGENDARY_RARITY]: 1,
    [EPIC_RARITY]: 2,
    [RARE_RARITY]: 3,
    [UNCOMMON_RARITY]: 4
})

// prod https://ipfs.io/ipfs/QmNYfH8gMDp3Nf3Ad4F4SonnubESPQqouN7WXT5rpfC49F
// stag https://ipfs.io/ipfs/QmbgYqfVh7HDGH39pU4gtjSp9RP15jKieMEnjW7RfZAWsN

// prod https://polygon-mainnet.g.alchemy.com/v2/eKuKKAwntZlBC73E0aYRsB3yZEMFSYXC

// console.log(abi)
// const contract = new web3.eth.Contract(abi, contractAddr);

// async function test() {   
//     const res = await contract.methods.ownerOf('22').call();
    
//     console.log(res.toString())
// }

// test();

// const baseUrl = process.env.REACT_APP_IPFS_METADATA_URL || "https://ipfs.io/ipfs/QmbgYqfVh7HDGH39pU4gtjSp9RP15jKieMEnjW7RfZAWsN";

// crawled metadata from IPFS
// stag https://oc-metadata.s3.amazonaws.com/publisher-nft/testnet/metadata.json
// prod https://oc-metadata.s3.amazonaws.com/publisher-nft/mainnet/metadata.json


function transform(data) {
    const newData = Object.assign({}, data)
    // unwrap the attributes array
    if(data.attributes) {
        data.attributes.forEach(x => {
            const key = x.trait_type.toLowerCase().split(' ').join('_').replace("id", "nft_id")
            newData[key] = x.value
        })
    }

    // ipfs -> http url
    if(data.image && data.image.includes("ipfs://")) {
        newData.image = data.image.replace("ipfs://", "https://ipfs.io/ipfs/")
    }

    return newData;
}

export async function fetchMetadataJson(signal) {
    try {
        // return metadata;
        // return metadata.reduce((acc, x) => {
        //     acc[x.id] = x;
        //     return acc;
        // }, {})
        const url = process.env.REACT_APP_METADATA_URL || "https://assets.opencampus.xyz/metadata/publisher/metadata-prod.json";
        
        const res = await fetch(url, { signal })
        if(res.ok) {
            const metadata = await res.json();

            return metadata.reduce((acc, x) => {
                acc[x.id] = x;
                return acc;
            }, {})

            // lowercase all keys in obj
            // return response.data.map(obj => {
            //     delete obj.ID;  // delete the capitalized ID, useless (?)
            //     return Object.fromEntries(
            //         Object.entries(obj).map(([k, v]) => [k.toLowerCase().split(' ').join('_'), v])
            //     )
            // })
        } else {
            throw "Failed to fetch full metadata from S3";
        }
    } catch(e) {
        throw e;
    }
}


export async function fetchMetadata(id, signal) {
    if(!id) throw 'Required field "id" missing in fetchMetadata()'

    // const url = `${baseUrl}/${id}`;
    // const res = await fetch(url, {
    //     signal
    // });

    // const data = await res.json();
    // return transform(data);

    try {
        const baseMetadata = await fetchMetadataJson(signal);
        return baseMetadata[id];
    } catch(e) {
        throw e;
    }
}


// export async function fetchPublisherRewardRate() {
//     try {
//         let baseMetadata = await fetchMetadataJson();
//         const yields = (await (await fetch('/yield.csv')).text()).split('\r\n');
//         console.log(baseMetadata[0], yields[0])
//         const tmp = Object.entries(baseMetadata).map(([k, v], i) => ({ 
//             ...v, yieldPerBlock: parseInt(yields[i].split(',')[1]) / (1e18)
//             // return {...v, yieldPerBlock: yieldPerBlock[v.id]} 
//         }))
//         const sorted = tmp.sort((a, b) => a.id > b.id)
//         console.log(JSON.stringify(sorted));

//         return tmp;
//     } catch (e) {
//         throw e;
//     }
// }

// fetchPublisherRewardRate();